import ApiConfig from 'config/api-config';

const config = new ApiConfig();
export default class Ayah {
  getAyah = (surah, ayah) => {
    return config.init().get(`/ayah/${surah}:${ayah}`);
  };
}
